import { HStack, Text, VStack } from '@chakra-ui/react';
import React from 'react';

const WIDTH = 260;
const HEIGHT = 128;
const TITLE_MAX_WIDTH = 130;

interface Props {
  title: string;
  trendIconJSX?: JSX.Element;
  bottomLeftText: string | number;
  bottomRightSmallText?: string;
  bottomRightLargeText?: string | number;
}

const OrgDashboardStatsItemBox = ({
  title,
  trendIconJSX,
  bottomLeftText,
  bottomRightSmallText,
  bottomRightLargeText,
}: Props) => {
  return (
    <VStack
      width={WIDTH}
      height={HEIGHT}
      boxShadow="0px 8px 34px 0px #0041791A"
      padding={'20px'}
      borderRadius={'14px'}
      backgroundColor={'extra.white'}
      justifyContent={'space-between'}
    >
      <HStack justifyContent={'space-between'} width={'100%'}>
        <Text
          maxWidth={TITLE_MAX_WIDTH}
          variant={'urbanistSemiBold'}
          color={'text.mediumGray'}
          textAlign={'start'}
          whiteSpace={'pre-wrap'}
        >
          {title}
        </Text>
        {trendIconJSX}
      </HStack>
      <HStack justifyContent={'space-between'} width={'100%'} alignItems={'end'}>
        <Text variant={'urbanistTitleBold'}>{bottomLeftText}</Text>
        {bottomRightSmallText && (
          <Text variant={'urbanistMedium'} color={'text.mediumGray'}>
            {bottomRightSmallText}
          </Text>
        )}
        {bottomRightLargeText && <Text variant={'urbanistTitleBold'}>{bottomRightLargeText}</Text>}
      </HStack>
    </VStack>
  );
};

export default OrgDashboardStatsItemBox;
